import * as crypto from "crypto";

export const generateHMAC = (
  key: string,
  value: string
): string | undefined => {
  if (!key || !value) return;

  const hmac = crypto.createHmac("sha256", key);
  hmac.update(value);

  return hmac.digest("hex");
};
